module.exports = __webpack_public_path__ + "static/media/sanchezsemibold.97454a27.woff2";